import { Fragment } from "react";
import classnames from "classnames";
import { Card, CardBody, CardText, UncontrolledTooltip } from "reactstrap";
import { Download, Play } from "react-feather";
import { store } from "@store/StoreConfig";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { BsMusicNoteList } from "react-icons/bs";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useTranslation } from "react-i18next";
const URL = process.env.REACT_APP_MICRO_PLANING_URL;
const shareUrl = window.location.origin;

const PodcastCards = (props) => {
  const { datas, activeView } = props;
  const { t } = useTranslation();
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  let data = {
    currentsong: null,
    download: null,
    namesong: null,
    songimg: "",
    is_web_rtc: false,
  };
  const renderdata = () => {
    if (datas?.length) {
      return datas?.map((item, i) => {
        return (
          <Card
            className="ecommerce-card"
            key={i}
            style={{ gridTemplateColumns: "2fr 2fr 1fr" }}
          >
            <div className="item-img text-center mx-auto">
              <Link to={`/podcast/${item.id}`}>
                <img
                  width="100%"
                  height="100%"
                  src={item.empic}
                  alt="emission_picture"
                />
              </Link>
            </div>
            <CardBody style={{ justifyContent: "space-between" }}>
              <div style={{ textAlign: "center" }}>
                <div className="item-cost">
                  <h6 className="item-price">
                    <div
                      className="text-center mx-auto cursor-pointer me-50 py-50"
                      style={{ flexDirection: "row" }}
                    >
                      <Link
                        to={`/podcast/${item.id}`}
                        style={{ marginRight: "5px" }}
                      >
                        <FaEye
                          style={{ display: "inline !important" }}
                          size={20}
                          id="Show"
                        />
                      </Link>
                      {PlayerFrontOfficeReducer?.currentSong === item.file ? (
                        <BsMusicNoteList color="#7367F0" size={20} />
                      ) : (
                        <Fragment>
                          <Play
                            className="mr-50 pointer_cursor "
                            id="Play"
                            color="#7367F0"
                            style={{ display: "inline !important" }}
                            size={20}
                            onClick={() =>
                              store.dispatch(
                                addMusic(
                                  (data = {
                                    currentsong: item.file,
                                    download: `${URL}/podcast/download/${item.id}`,
                                    namesong: `${item.podcastname}`,
                                    songimg: item.empic,
                                    item_data: item,
                                    is_web_rtc: false,
                                    has_video:
                                      item.podcastname.endsWith("mp4") && true,
                                  })
                                )
                              )
                            }
                          />
                          <UncontrolledTooltip placement="bottom" target="Play">
                            {t("Play")}
                          </UncontrolledTooltip>
                        </Fragment>
                      )}
                      <a
                        href={`${URL}/podcast/download/${item.id}`}
                        style={{ textDecoration: "black" }}
                        download
                      >
                        <Download
                          size={20}
                          className="mr-50 pointer_cursor"
                          id="Download"
                        />
                      </a>
                      <UncontrolledTooltip placement="bottom" target="Download">
                        {t("Download")}
                      </UncontrolledTooltip>
                    </div>
                  </h6>
                </div>
              </div>
              <CardText
                tag="div"
                className="item-name"
                style={{
                  maxWidth: "250px",
                }}
              >
                <span className="mr-50 pointer_cursor" id="emissionanme">
                  <div className="mail-body">
                    <div className="mail-message">
                      <p className="text-truncate">
                        {t("Emission name")}: {item.emname}
                      </p>
                    </div>
                  </div>
                </span>
              </CardText>
              <CardText
                tag="div"
                className="item-name"
                style={{
                  maxWidth: "250px",
                }}
              >
                <div className="mail-body">
                  <div className="mail-message">
                    <p className="text-truncate mb-0">
                      {t("Episode name")}: {item.epname}
                    </p>
                  </div>
                </div>
              </CardText>
              <CardText tag="div" className="item-description">
                <p>
                  {t("Date")}: {item.record_datetime}
                </p>
              </CardText>
              <div className="item-cost">
                <h6 className="item-price">
                  <CardText tag="div">
                    <ul
                      className="blog-icon-podcast"
                      style={{ textAlign: "center" }}
                    >
                      <li>
                        <FacebookShareButton
                          url={`${shareUrl}/podcast/${item.id}`}
                        >
                          <FacebookIcon size={30} round={true} />
                        </FacebookShareButton>
                      </li>

                      <li>
                        <TwitterShareButton
                          url={`${shareUrl}/podcast/${item.id}`}
                        >
                          <TwitterIcon size={30} round={true} />
                        </TwitterShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton
                          url={`${shareUrl}/podcast/${item.id}`}
                        >
                          <WhatsappIcon size={30} round={true} />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <FacebookMessengerShareButton
                          url={`${shareUrl}/podcast/${item.id}`}
                        >
                          <FacebookMessengerIcon size={30} round={true} />
                        </FacebookMessengerShareButton>
                      </li>
                    </ul>
                  </CardText>
                </h6>
              </div>
            </CardBody>
            <div className="item-options text-center">
              <h4 className="item-price">
                <div
                  className="text-center mx-auto cursor-pointer me-50 py-50"
                  style={{ flexDirection: "row" }}
                >
                  <Link
                    to={`/podcast/${item.id}`}
                    style={{ marginRight: "5px" }}
                  >
                    <FaEye
                      style={{ display: "inline !important" }}
                      size={20}
                      id="Show"
                    />
                  </Link>
                  {PlayerFrontOfficeReducer?.currentSong === item.file ? (
                    <BsMusicNoteList color="#7367F0" size={20} />
                  ) : (
                    <Fragment>
                      <Play
                        className="mr-50 pointer_cursor "
                        id="Play"
                        color="#7367F0"
                        style={{ display: "inline !important" }}
                        size={20}
                        onClick={() =>
                          store.dispatch(
                            addMusic(
                              (data = {
                                currentsong: item.file,
                                download: `${URL}/podcast/download/${item.id}`,
                                namesong: `${item.podcastname}`,
                                songimg: item.empic,
                                item_data: item,
                                is_web_rtc: false,
                                has_video:
                                  item.podcastname.endsWith("mp4") && true,
                              })
                            )
                          )
                        }
                      />
                      <UncontrolledTooltip placement="bottom" target="Play">
                        {t("Play")}
                      </UncontrolledTooltip>
                    </Fragment>
                  )}
                  <a
                    href={`${URL}/podcast/download/${item.id}`}
                    style={{ textDecoration: "black" }}
                    download
                  >
                    <Download
                      size={20}
                      className="mr-50 pointer_cursor"
                      id="Download"
                    />
                  </a>
                  <UncontrolledTooltip placement="bottom" target="Download">
                    {t("Download")}
                  </UncontrolledTooltip>
                </div>
                <CardText tag="div">
                  <ul
                    className="blog-icon-podcast"
                    style={{ textAlign: "center" }}
                  >
                    <li>
                      <FacebookShareButton
                        url={`${shareUrl}/podcast/${item.id}`}
                      >
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>

                    <li>
                      <TwitterShareButton
                        url={`${shareUrl}/podcast/${item.id}`}
                      >
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton
                        url={`${shareUrl}/podcast/${item.id}`}
                      >
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton
                        url={`${shareUrl}/podcast/${item.id}`}
                      >
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                  </ul>
                </CardText>
              </h4>
            </div>
          </Card>
        );
      });
    }
  };

  return (
    <div
      className={classnames({
        "grid-view": activeView === "grid",
        "list-view": activeView === "list",
      })}
    >
      {renderdata()}
    </div>
  );
};

export default PodcastCards;
